import { render, staticRenderFns } from "./yc-sampling.vue?vue&type=template&id=12dda059&scoped=true&"
import script from "./yc-sampling.vue?vue&type=script&lang=js&"
export * from "./yc-sampling.vue?vue&type=script&lang=js&"
import style0 from "./yc-sampling.vue?vue&type=style&index=0&id=12dda059&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dda059",
  null
  
)

export default component.exports